import React from 'react';

function TarjetaMenu({item}) {
 
    return (
        <div className="col-md-4 col-6 d-flex justify-content-center" style={{padding:"5px"}} >
           
            <div className="row border rounded"  style={{width:"90%",padding:"5px"}}>
                <div className='col-md-4'>
                {item.permitido?
                    <div className="cajaIcono">
                        <i className={item.icono} style={{width:"80%"}}/>
                    </div>:
                    <div className="cajaIconoDeshabilitado">
                        <i className={item.icono}/>
                    </div>
                }  
                </div>
                <div className="col-md-8" style={{padding:"3px"}}>
                    <h5>{item.nombre}</h5>
                    <p className="card-text d-none d-md-block" style={{ height:"60px"}}>{item.descripcion}</p>
                            {item.permitido?
                                <a href={item.url} className="btn btn-formulario" style={{bottom:"0"}}>ingresar</a>:''
                            }
                </div>
            </div>
            
        </div>

    );
}

export default TarjetaMenu;